import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderMiradas } from "../../../components/Landing/Header/headerMiradas";
import { Footer } from "../../../components/Landing/Footer";
import { SEO } from "../../../components/SEO/SEO";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import banner2026 from "../../../assets/miradas/banner2026.png"

// El póster oficial vive en public/ para poder reemplazarlo sin recompilar.
const posterImage = process.env.PUBLIC_URL + encodeURI("/assets/miradas/PHOTO-2026-10-27-15-39-45.jpg");

// Carpeta de Drive con las fotos de la galería. Debe estar compartida como
// "cualquiera con el enlace" para que el visor embebido muestre las miniaturas.
const GALERIA_DRIVE_FOLDER_ID = "1kdsyCL7jn2P9aCU10TjTCmkAvj6LEXR3";

export const MiradasPrensa = () => {
  const navigate = useNavigate();

  const handleNavigation = (route: string) => {
    navigate(route);
  };

  return (
    <>
      <SEO
        title="Prensa Miradas Medellín"
        description="Información y recursos para medios de comunicación sobre Miradas Medellín, el evento de cine iberoamericano contemporáneo."
        keywords="prensa Miradas Medellín, kit de prensa, medios comunicación, Cinemateca Distrital, cine iberoamericano, fotografías Miradas"
        ogTitle="Prensa Miradas Medellín"
        ogDescription="Información y recursos para medios de comunicación sobre Miradas Medellín."
        ogUrl={`${window.location.origin}/estimuloscultura/miradasPrensa`}
      />
      <Header />
      <HeaderMiradas />
      <img src={banner2026} alt="Miradas Medellín 2026" style={{ width: "100%", height: "auto", objectFit: "cover" }} />

      {/* SECCIÓN 1: INTRODUCCIÓN */}
      <div className="container-fluid2" style={{ maxWidth: "800px", margin: "0 auto", padding: "60px 20px" }}>
        <h1 className="sr-only">Prensa Miradas 2026</h1>
        <h2 className="mb-4 text-center" style={{ fontWeight: "bold", fontSize: "28px", color: "#000" }}>
          Miradas Medellín 2026. El lugar del nuevo cine iberoamericano.
        </h2>
        <div style={{ fontSize: "16px", textAlign: "justify", color: "#333", lineHeight: "1.6" }}>
          <p className="mb-4">
            Del 3 al 8 de noviembre, Medellín y otros municipios del Área Metropolitana serán escenario de encuentros entre nuevas historias, cineastas, públicos y profesionales del sector audiovisual.
          </p>
          <p className="mb-4">
            En este espacio encontrarás información oficial de Miradas Medellín 2026, comunicados de prensa y recursos gráficos y audiovisuales para conocer y contar esta edición del Festival de Cine y Artes Audiovisuales.
          </p>
          <p className="mb-0">
            Miradas Medellín es un evento de la <strong>Alcaldía de Medellín</strong> a través de la Cinemateca Distrital de Medellín y la Comisión Fílmica, que promueve el encuentro alrededor del cine iberoamericano contemporáneo y fortalece los procesos de creación, formación y circulación audiovisual en la ciudad.
          </p>
        </div>
      </div>

      {/* SECCIÓN 2: INFORMACIÓN DE PRENSA / KIT */}
      <div style={{ padding: "20px 20px 60px 20px", display: "flex", justifyContent: "center" }}>
        <div style={{ maxWidth: "800px", width: "100%" }}>
          <div style={{ backgroundColor: "#22253b", color: "white", padding: "15px", textAlign: "center", marginBottom: "30px" }}>
            <h2 style={{ margin: 0, fontWeight: "bold", color: "white", fontSize: "24px" }}>
              Información de prensa
            </h2>
          </div>

          <div className="text-center" style={{ padding: "0 20px" }}>
            <p style={{ fontSize: "16px", marginBottom: "30px" }}>
              Consulta y descarga información institucional y recursos oficiales de Miradas Medellín.
            </p>
            <Button
              type="primary"
              href="https://drive.google.com/drive/folders/1AQllC0HYiK03GrUCVa8B_f7X6S-MUBtD"
              target="_blank"
              rel="noopener noreferrer"
              style={{ backgroundColor: '#2e66d2', borderColor: '#2e66d2', fontSize: '16px', fontWeight: "bold", height: 'auto', padding: '10px 30px', borderRadius: '5px' }}
            >
              Kit de Prensa Miradas 2026
            </Button>
          </div>
        </div>
      </div>

      {/* SECCIÓN 3: GALERÍA 2025 */}
      <div style={{ padding: "20px 20px 60px 20px" }}>
        <div className="container-fluid2" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <h2 className="mb-4 text-center" style={{ fontWeight: "bold", fontSize: "28px", color: "#000" }}>
            Galería 2025
          </h2>

          {/* Galería embebida directamente desde la carpeta de Drive (miniaturas). */}
          <div style={{ backgroundColor: "#fff", border: "1px solid #e0e0e0", borderRadius: "8px", overflow: "hidden", marginBottom: "30px" }}>
            <iframe
              src={`https://drive.google.com/embeddedfolderview?id=${GALERIA_DRIVE_FOLDER_ID}#grid`}
              title="Galería de fotografías - Miradas Medellín 2025"
              style={{ width: "100%", height: "60vh", minHeight: "400px", border: "none", display: "block" }}
            />
          </div>

          <div className="text-center">
            <p style={{ fontSize: "16px", marginBottom: "20px" }}>
              Accede a una selección de imágenes de las ediciones anteriores de Miradas Medellín, sus invitados, actividades y espacios de programación.
            </p>
            <Button
              type="primary"
              href={`https://drive.google.com/drive/folders/${GALERIA_DRIVE_FOLDER_ID}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ backgroundColor: '#2e66d2', borderColor: '#2e66d2', fontSize: '16px', fontWeight: "bold", height: 'auto', padding: '10px 30px', borderRadius: '5px' }}
            >
              Ver fotografías
            </Button>
          </div>
        </div>
      </div>

      {/* SECCIÓN 4: PÓSTER */}
      <div style={{ padding: "40px 20px", backgroundColor: "#f9f9f9" }}>
        <div className="container-fluid2 text-center" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 style={{ fontWeight: "bold", fontSize: "24px", color: "#000", marginBottom: "20px" }}>
            Póster
          </h2>
          <img
            src={posterImage}
            alt="Póster oficial de Miradas Medellín 2026"
            style={{ width: "100%", maxWidth: "400px", height: "auto", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}
          />
        </div>
      </div>

      {/* SECCIÓN 5: PREGUNTAS FRECUENTES */}
      <div style={{ padding: "40px 20px" }}>
        <div className="container-fluid2 text-center" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 style={{ fontWeight: "bold", fontSize: "24px", color: "#000", marginBottom: "20px" }}>
            Preguntas frecuentes Miradas Medellín 2026
          </h2>
          <p style={{ fontSize: "16px", color: "#333", margin: 0 }}>
            Próximamente más información.
          </p>
        </div>
      </div>

      {/* SECCIÓN 6: CONTACTO DE PRENSA */}
      <div style={{ padding: "60px 20px 80px 20px" }}>
        <div className="container-fluid2" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <h2 className="text-center" style={{ fontWeight: "bold", fontSize: "26px", color: "#000", marginBottom: "20px" }}>
            Contacto de prensa
          </h2>
          <p className="text-center" style={{ fontSize: "16px", marginBottom: "40px", color: "#333" }}>
            Para entrevistas, solicitudes de información o requerimientos de medios de comunicación:
          </p>

          <div className="row justify-content-center g-4">
            <div className="col-md-5">
              <div style={{ backgroundColor: "#eef0f6", padding: "30px", borderRadius: "10px", height: "100%", textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <p style={{ margin: 0, fontSize: "16px", color: "#333" }}>Alexandra Duque</p>
                <p style={{ margin: 0, fontSize: "16px", fontWeight: "bold", color: "#000" }}>Comunicadora Cinemateca Distrital</p>
                <a href="mailto:ccinemateca.fcf@udea.edu.co" style={{ fontSize: "16px", color: "#333", textDecoration: "underline", display: "block", marginTop: "5px" }}>ccinemateca.fcf@udea.edu.co</a>
                <p style={{ margin: 0, fontSize: "16px", color: "#333", marginTop: "5px" }}>3237957739</p>
              </div>
            </div>

            <div className="col-md-5">
              <div style={{ backgroundColor: "#eef0f6", padding: "30px", borderRadius: "10px", height: "100%", textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <p style={{ margin: 0, fontSize: "16px", color: "#333" }}>César Montoya</p>
                <p style={{ margin: 0, fontSize: "16px", fontWeight: "bold", color: "#000" }}>Prensa Secretaría de Cultura de la Alcaldía de Medellín</p>
                <p style={{ margin: 0, fontSize: "16px", color: "#333", marginTop: "5px" }}>+57 300 6620268</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SECCIÓN 7: EXPLORA TODA LA EXPERIENCIA */}
      <div style={{ padding: "40px 20px 80px 20px", backgroundColor: "#f9f9f9" }}>
        <div className="container-fluid2 text-center" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 style={{ fontWeight: "bold", fontSize: "24px", color: "#000", marginBottom: "20px" }}>
            Explora toda la experiencia Miradas Medellín
          </h2>
          <p style={{ fontSize: "16px", marginBottom: "30px", color: "#333" }}>
            Consulta la programación del festival y descubre las películas, actividades y experiencias abiertas a la ciudadanía.
          </p>
          <Button
            type="primary"
            style={{ backgroundColor: '#2e66d2', borderColor: '#2e66d2', fontSize: '16px', fontWeight: "bold", height: 'auto', padding: '10px 30px', borderRadius: '5px' }}
            onClick={() => handleNavigation('/miradasProgramacion')}
          >
            Ver programación
          </Button>
        </div>
      </div>

      <Footer />
    </>
  );
};
